'use strict';

var util = require('../../util/property-util');
var arrayUtil = require('../../util/array-util');
var zabbixUtil = require('../../monitoring/pages/alarm/zabbix-util');

module.exports = /*@ngInject*/ function () {
    var factory = {};

    /**
     * Filters the given data to only include relevant data objects.
     * Relevant data objects are objects that can be used by selected properties of the given messageName.
     * Data that can never be used by any of the selected properties, is discarded.
     * @param data              -   Array of data objects, typically data from the database
     * @param messageName       -   Name of the message
     * @param messageStructure  -   The objectFactory that contains the message structure
     * @returns {Array}
     */
    factory.filterData = function (data, messageName, messageStructure) {
        "use strict";

        var selectedProperties = messageStructure.getCheckedProperties(messageName);
        var discriminatorField = messageStructure.getDiscriminatorField(messageName);
        var subDiscriminatorField = messageStructure.getSubDiscriminatorField(messageName);
        var filteredData = [];
        if (messageStructure.hasDiscriminator(messageName)) {
            if (messageStructure.hasSubDiscriminator(messageName)) {
                data.forEach(function (entry) {
                    var discriminatorProperties = zabbixUtil.getArrayFilteredOn(selectedProperties, 'discriminatorName', entry[discriminatorField]);
                    var subDiscriminatorProperty = arrayUtil.getFirstInList(discriminatorProperties, 'subDiscriminatorName', entry[subDiscriminatorField]);

                    if (util.isDefined(subDiscriminatorProperty)) {
                        filteredData.push(entry);
                    }
                });
            } else {
                data.forEach(function (entry) {
                    var discriminatorProperties = arrayUtil.getFirstInList(selectedProperties, 'discriminatorName', entry[discriminatorField]);

                    if (util.isDefined(discriminatorProperties)) {
                        filteredData.push(entry);
                    }
                });
            }
        } else {
            filteredData = data;
        }

        return filteredData;
    };

    /**
     * Filters the given data to only include relevant data objects.
     * Relevant data objects are objects that can be used by selected properties of the given messageName.
     * Data that can never be used by any of the selected properties, is discarded.
     * @param data              -   Array of data objects, typically data from the database
     * @param messageStructure  -   The objectFactory that contains the message structure
     * @returns {Array}
     */
    factory.filterDataOnCurrent = function (data, messageStructure) {
        "use strict";

        var selectedProperties = messageStructure.getCurrentCheckedProperties();
        var discriminatorField = messageStructure.getDiscriminatorField();
        var subDiscriminatorField = messageStructure.getSubDiscriminatorField();
        var filteredData = [];
        if (messageStructure.hasDiscriminator()) {
            if (messageStructure.hasSubDiscriminator()) {
                data.forEach(function (entry) {
                    var discriminatorProperties = zabbixUtil.getArrayFilteredOn(selectedProperties, 'discriminatorName', entry[discriminatorField]);
                    var subDiscriminatorProperty = arrayUtil.getFirstInList(discriminatorProperties, 'subDiscriminatorName', entry[subDiscriminatorField]);

                    if (util.isDefined(subDiscriminatorProperty)) {
                        filteredData.push(entry);
                    }
                });
            } else {
                data.forEach(function (entry) {
                    var discriminatorProperties = arrayUtil.getFirstInList(selectedProperties, 'discriminatorName', entry[discriminatorField]);

                    if (util.isDefined(discriminatorProperties)) {
                        filteredData.push(entry);
                    }
                });
            }
        } else {
            filteredData = data;
        }

        return filteredData;
    };

    /**
     * Function filters the given properties and only returns properties that have to be used with the current data entry.
     * For example when the data entry has the discriminator box1 and modem_0 and messageName mar3LinkStatistics,
     * the function will only return properties that are selected for these values.
     * @param selectedProperties    -   List of selected properties
     * @param entry     -   Data entry
     * @param messageName   -   messageName of the statistic
     * @param messageStructure  -  MessageStructureFactory
     * @returns {Array}
     */
    factory.filterPropertiesForEntry = function (selectedProperties, entry, messageName, messageStructure) {
        "use strict";

        var discriminatorField = messageStructure.getDiscriminatorField(messageName);
        var subDiscriminatorField = messageStructure.getSubDiscriminatorField(messageName);

        var filteredData = [];
        var discriminatorProperties;
        if (messageStructure.hasDiscriminator(messageName)) {
            if (messageStructure.hasSubDiscriminator(messageName)) {
                discriminatorProperties = zabbixUtil.getArrayFilteredOn(selectedProperties, 'discriminatorName', entry[discriminatorField]);
                var subDiscriminatorProperty = zabbixUtil.getArrayFilteredOn(discriminatorProperties, 'subDiscriminatorName', entry[subDiscriminatorField]);

                if (util.isDefined(subDiscriminatorProperty)) {
                    filteredData = filteredData.concat(subDiscriminatorProperty);
                }
            } else {
                discriminatorProperties = zabbixUtil.getArrayFilteredOn(selectedProperties, 'discriminatorName', entry[discriminatorField]);

                if (util.isDefined(discriminatorProperties)) {
                    filteredData = filteredData.concat(discriminatorProperties);
                }
            }
        } else {
            filteredData = selectedProperties;
        }
        return filteredData;
    };

    factory.getUniqueEntryId = function (entry, messageName, messageStructure) {
        var discriminatorField = messageStructure.getDiscriminatorField(messageName);
        var subDiscriminatorField = messageStructure.getSubDiscriminatorField(messageName);
        if (messageStructure.hasDiscriminator(messageName)) {
            if (messageStructure.hasSubDiscriminator(messageName)) {
                return entry[discriminatorField] + "_" + entry[subDiscriminatorField];
            } else {
                return entry[discriminatorField];
            }
        } else {
            return messageName;
        }
    };
    return factory;
};